module.exports = __webpack_public_path__ + "static/media/Resume-Gayuru.971bb4fb.pdf";